<template>
  <form class="form">
    <h2>Рейтинг-лист направлений подготовки/специальностей</h2>
    <template v-for="section in sections">
      <h3>{{ section.name }}</h3>
      <div class="form__input">
        <ol class="list list--priorities">
          <li class="list__item" v-for="group in section.groups" :key="group.priority" :value="group.priority">
            <template v-for="item in group.items" :key="item.id">
              <div class="card">
                <div class="card__header">
                  <h5 class="join join--col join--indent-sm">
                    <span>
                      <a v-if="item.url" :href="item.url" target="_blank">{{ item.name }}</a>
                      <span v-else>{{ item.name }}</span>
                    </span>
                    <span class="join join--wrap join--indent-sm">
                      <span
                        v-for="badge in badges(item)"
                        :key="badge.text"
                        class="badge badge--pill"
                        :class="badge.class"
                      >
                        {{ badge.text }}
                      </span>
                    </span>
                  </h5>
                </div>
              </div>
              <ul class="list">
                <li class="list__item list__item--xs card" v-for="profile in item.profiles" :key="profile.id">
                  <small>{{ profile.name }}</small>
                </li>
              </ul>
            </template>
          </li>
        </ol>
      </div>
    </template>
  </form>
</template>

<script setup>
import { computed } from 'vue'
import { useApplicationStore } from '@widgets/application-profile'

const store = useApplicationStore()

const allItems = computed(() => store.application.rating_lists?.flatMap(rl => rl.items) ?? [])

const budgetItems = computed(() => {
  const list = store.application.rating_lists?.find(rl => rl.kind === 'budget')
  return (list?.items ?? []).filter(item => item.status !== 'Отозвано')
})

const payItems = computed(() => {
  const list = store.application.rating_lists?.find(rl => rl.kind === 'pay')
  return (list?.items ?? []).filter(item => item.status !== 'Отозвано')
})

const withdrawnItems = computed(() => allItems.value.filter(item => item.status === 'Отозвано'))

const sections = computed(() => {
  return [
    { name: 'Бюджетные направления подготовки/специальности', groups: groupedItemsByRules(budgetItems.value) },
    { name: 'Платные направления подготовки/специальности', groups: groupedItemsByRules(payItems.value) },
    { name: 'Отозванные направления подготовки/специальности', groups: groupedItemsByRules(withdrawnItems.value) },
  ].filter(item => item.groups.length)
})

const groupedItemsByRules = (items) => {
  const groups = {}

  // создаем группы и объединяем их по приоритету получится объект вида
  // { 1: {priority: 1, items: []}, 2: {priority: 2, items: []} }
  items.forEach(item => {
    groups[item.priority] ??= { priority: item.priority, items: [] }
    groups[item.priority].items.push(item)
  })

  //переводим в массив для более удобной работы [{}, {}]
  const arrayGroups = Object.values(groups)


  const weight = (item) => {
    if (item.reception_feature === 'Отдельная квота') return 1
    if (item.reception_feature === 'Общие места' && item.benefits_only) return 2
    if (item.reception_feature === 'Общие места') return 3
    return 4
  }

  // сортируем по полю reception_feature and benefits_only
  arrayGroups.forEach(group => {
    group.items.sort((a, b) => weight(a) - weight(b))
  })

  return arrayGroups
}

const badges = (item) => {
  const result = []
  if (item.status) result.push({ text: `Статус: ${item.status}`, class: statusBadgeClass(item) })

  if (item.priorities?.is_highest_priority) result.push({ text: 'Основной высший приоритет', class: 'badge--solid-success' })
  if (item.priorities?.is_highest_passing_priority) result.push({ text: 'Высший проходной приоритет', class: 'badge--solid-success' })
  if (item.without_exam) result.push({ text: 'Без вступительных испытаний', class: 'badge--solid-success' })

  if (item.is_combined_quota) result.push({ text: 'Совмещённая квота', class: 'badge--solid-primary' })
  if (item.benefits_only) result.push({ text: 'Льгота', class: 'badge--solid-primary' })

  if (item.only_russian) result.push({ text: 'Для граждан РФ', class: 'badge--solid-muted' })
  if (item.is_spo) result.push({ text: 'СПО', class: 'badge--solid-muted' })
  if (item.is_vo) result.push({ text: 'ВО', class: 'badge--solid-muted' })

  return result
}

const statusBadgeClass = (item) => item.status === 'Отозвано' ? 'badge--status-danger' : 'badge--status'
</script>
